/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import { ANOMALY_NAVIGATION_CONFIGS } from '@/config/kpi/overviewAnomalyConfig';

/* Import components */
import AnomalyMetricsOverview from '@/components/tabs/overview/metrics/AnomalyMetricsOverview';

function AnomaliesTab() {
    return (
        <AnomalyMetricsOverview
            anomalyConfigs={ANOMALY_NAVIGATION_CONFIGS}
            description="Select an anomaly to open its dashboard and related metrics:"
            gridClassName="xl:grid-cols-3"
            groupBy="anomaly"
            heading="Anomalies"
            idPrefix="anomalies"
        />
    );
}

export default AnomaliesTab;
